import EmblaCarousel from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Autoplay from 'embla-carousel-autoplay'

const WorklistSlideshowElement = document.querySelector('.Worklist-slideshow')
const WorklistButtons = document.querySelectorAll('.Worklist-workButton')

function selectWorklistImage(emblaApi) {
  const currentIndex = emblaApi.selectedScrollSnap()

  Array.prototype.forEach.call(WorklistButtons, function (button) {
    button.classList.remove('Worklist-workButton--current')
  })

  const currentButton = document.querySelector(
    '.Worklist-workButton[data-image-key="' + currentIndex + '"]',
  )

  currentButton.classList.add('Worklist-workButton--current')
}

if (WorklistSlideshowElement) {
  let options = { loop: true }
  let plugins = [WheelGesturesPlugin()]

  const autoplayPlugin = Autoplay({
    playOnInit: true,
    delay: 6000,
    stopOnMouseEnter: true,
    stopOnInteraction: false,
  })

  options = { loop: true, playOnInit: true }
  plugins = [WheelGesturesPlugin(), autoplayPlugin]

  const worklistSlideshowApi = EmblaCarousel(
    WorklistSlideshowElement,
    options,
    plugins,
  )

  Array.prototype.forEach.call(WorklistButtons, function (button) {
    button.addEventListener('click', () => {
      worklistSlideshowApi.scrollTo(button.getAttribute('data-image-key'))

      autoplayPlugin.stop()

      setTimeout(() => {
        autoplayPlugin.play()
      }, 10000)
    })
  })

  worklistSlideshowApi.on('select', selectWorklistImage)

  const WorklistCaptionButtons = document.querySelectorAll(
    '.Worklist-slideshowItemCaptionButton',
  )

  if (WorklistCaptionButtons) {
    Array.prototype.forEach.call(
      WorklistCaptionButtons,
      function (captionButtonElement) {
        captionButtonElement.addEventListener('click', () => {
          const itemElement = document.querySelector(
            '#' + captionButtonElement.getAttribute('aria-controls'),
          )

          if (
            !captionButtonElement.getAttribute('aria-expanded') ||
            captionButtonElement.getAttribute('aria-expanded') == 'false'
          ) {
            captionButtonElement.setAttribute('aria-expanded', true)
            itemElement.classList.add('Worklist-slideshowItem--captionExpanded')
          } else {
            captionButtonElement.setAttribute('aria-expanded', false)
            itemElement.classList.remove(
              'Worklist-slideshowItem--captionExpanded',
            )
          }
        })
      },
    )
  }
}
